export default __webpack_public_path__ + "static/media/Hand-Paper-Frame.5c896ddf.png";